export default __webpack_public_path__ + "static/media/user_profile.9a91f9fa.svg";